import React from 'react';
import { Box, Typography, Grid2, Paper, useTheme, Icon } from '@mui/material';
import Section from './Section';

const SeccionEstadisticas = () => {
  const theme = useTheme();

  const estadisticasTypes = [
    {
      title: 'Estadísticas de Boletos',
      description: 'Tablero gráfico con el desglose exacto de boletos disponibles, reservados y pagados en porcentaje.',
      icon: 'pie_chart',
      color: theme.palette.primary.main,
    },
    {
      title: 'Métricas Financieras',
      description: 'Muestra el total recaudado, dinero pendiente por cobrar de boletos reservados y proyección total del sorteo.',
      icon: 'payments',
      color: theme.palette.secondary.main,
    },
    {
      title: 'Exportación de Reportes',
      description: 'Genera archivos en Excel, PDF o CSV con el listado completo de compradores y números asignados.',
      icon: 'file_download',
      color: '#10b981',
    },
  ];

  return (
    <Section
      title="Estadísticas y Reportes en Tiempo Real"
      subtitle="Obtén una visión clara del rendimiento de tus rifas y de los ingresos generados:"
      hasBackground={false}
      id="estadisticas"
    >
      <Grid2 container spacing={3}>
        {estadisticasTypes.map((item, index) => (
          <Grid2 key={index} size={{ xs: 12, md: 4 }}>
            <Paper
              elevation={0}
              sx={{
                p: 3.2,
                height: '100%',
                borderRadius: '16px',
                bgcolor: theme.palette.background.paper,
                border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid #e2e8f0',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: theme.palette.mode === 'dark' ? '0 4px 16px rgba(0, 0, 0, 0.3)' : '0 2px 10px rgba(0, 0, 0, 0.03)',
                transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
                '&:hover': {
                  transform: 'translateY(-6px)',
                  boxShadow: theme.palette.mode === 'dark' ? '0 14px 32px rgba(0, 0, 0, 0.6)' : '0 14px 32px rgba(45, 52, 132, 0.12)',
                  borderColor: item.color,
                  '& .stats-icon-box': {
                    transform: 'scale(1.12) rotate(4deg)',
                    bgcolor: `${item.color}15`,
                    borderColor: item.color,
                  },
                },
              }}
            >
              {/* Outlined Icon Container con micro-animación */}
              <Box
                className="stats-icon-box"
                sx={{
                  width: 52,
                  height: 52,
                  borderRadius: '12px',
                  bgcolor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : '#f8fafc',
                  border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid #e2e8f0',
                  color: item.color,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 2.2,
                  transition: 'all 0.3s ease',
                }}
              >
                <Icon sx={{ fontSize: 26, color: item.color }}>{item.icon}</Icon>
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 800, mb: 1, color: theme.palette.text.primary, fontSize: '1.05rem' }}>
                {item.title}
              </Typography>
              <Typography variant="body2" sx={{ color: theme.palette.text.secondary, lineHeight: 1.6, flex: 1 }}>
                {item.description}
              </Typography>
            </Paper>
          </Grid2>
        ))}
      </Grid2>
    </Section>
  );
};

export default SeccionEstadisticas;